/* global Promise */
import * as R from 'ramda';
import angular from 'angular';

export default function EditVendorDialogController(
  $q,
  $scope,
  $timeout,
  $rootScope,

  alerts,
  confirmDialog,
  loaderService,
  orgDataService,
  ssDialogService,
  theSafeSharedModelService,
  userService,
  vmDataService,
  vmSharedModelService,
  editProductDialog,
  assignVendorManagersDialog,
  editAlertRecipientDialog,
  editVendorDialog
) {
  const vm = this;

  vm.newVendor = { ...vm.vendor };

  vm.usaAddress = null;
  vm.canadaAddress = null;

  vm.handleCloseDialog = handleCloseDialog;
  vm.handleTaxIdChange = handleTaxIdChange;
  vm.handleAddProduct = handleAddProduct;
  vm.handleEditProduct = handleEditProduct;
  vm.handleDeleteProduct = handleDeleteProduct;
  vm.handleAssignVendorManagers = handleAssignVendorManagers;
  vm.handleUnassignVendorManager = handleUnassignVendorManager;
  vm.handleAddAlertRecipient = handleAddAlertRecipient;
  vm.handleEditAlertRecipient = handleEditAlertRecipient;
  vm.handleDeleteAlertRecipient = handleDeleteAlertRecipient;
  vm.handleEditVendorFormSubmit = handleEditVendorFormSubmit;

  _activate();

  /** ****************************************
   * Event Handlers
   */

  function handleCloseDialog() {
    _closeDialog();
  }

  function handleTaxIdChange() {
    if (vm.newVendor.fullTaxId !== undefined) {
      vm.newVendor.taxId = vm.newVendor.fullTaxId.replace(/-/g, '');
    }
  }

  function handleAddProduct($event) {
    if ($scope.editVendorForm.$valid) {
      if (vm.newVendor.name !== '' && vm.newVendor.name !== null) {
        loaderService.showViewLoader = true;
        _saveVendor().then(() => {
          loaderService.showViewLoader = false;
          _showEditProductDialog($event, {
            masterVendorId: vm.vendor.masterVendorId,
            product: {
              vendorId: vm.vendor.vendorId,
              productId: -1
            },
            vendor: vm.vendor,
            addCallback: _handleAddedProduct,
          });
        });
      } else {
        alerts.error('A Vendor Name must be entered before a product can be added.');
      }
    }
  }

  function handleEditProduct($event, product) {
    if ($scope.editVendorForm.$valid) {
      loaderService.showViewLoader = true;
      _saveVendor().then(() => {
        vmDataService.getProductDetails(product.productId).then((response) => {
          loaderService.showViewLoader = false;
          const productDetails = response.data;

          angular.extend(product, productDetails);
          _showEditProductDialog($event, {
            masterVendorId: vm.vendor.masterVendorId,
            product,
            vendor: vm.vendor,
            addCallback: null
          });
        });
      });
    }
  }

  function handleDeleteProduct($event, product) {
    return _showDeleteProductDialog($event, product);
  }

  function handleAssignVendorManagers($event) {
    if ($scope.editVendorForm.$valid) {
      if (vm.newVendor.name !== '' && vm.newVendor.name !== null) {
        loaderService.showViewLoader = true;
        _saveVendor().then(() => {
          vmDataService.getVendorManagers(vm.vendor.vendorId, true).then((response) => {
            loaderService.showViewLoader = false;
            const vendorManagers = response.data.result;

            angular.forEach(vendorManagers, (custVM) => {
              custVM.isAssigned = false;
              angular.forEach(vm.vendor.vendorManagers, (vendorVM) => {
                if (custVM.vendorManagerId === vendorVM.vendorManagerId) {
                  custVM.isAssigned = true;
                }
              });
            });

            _showAssignVendorManagersDialog($event, {
              vendorId: vm.vendor.vendorId,
              vendorManagers,
              addCallback: _handleAddedVendorManagers
            });
          });
        });
      } else {
        alerts.error('A Vendor Name must be entered before Vendor Managers can be assigned.');
      }
    }
  }

  function handleUnassignVendorManager($event, vendorManager) {
    return _showUnassignVendorManagerDialog($event, vendorManager);
  }

  function handleAddAlertRecipient($event) {
    if ($scope.editVendorForm.$valid) {
      if (vm.newVendor.name !== '' && vm.newVendor.name !== null) {
        loaderService.showViewLoader = true;
        _saveVendor().then(() => {
          loaderService.showViewLoader = false;
          _showEditAlertRecipientDialog($event, {
            alertRecipient: {
              alertRecipientId: -1,
              atCustId: userService.user.atcustId,
              vendorId: vm.vendor.vendorId,
            },
            addCallback: _handleAddedAlertRecipient
          });
        });
      } else {
        alerts.error('A Vendor Name must be entered before Alert Recipients can be assigned.');
      }
    }
  }

  function handleEditAlertRecipient($event, alertRecipient) {
    if ($scope.editVendorForm.$valid) {
      loaderService.showViewLoader = true;
      _saveVendor().then(() => {
        loaderService.showViewLoader = false;
        _showEditAlertRecipientDialog($event, {
          alertRecipient,
        });
      });
    }
  }

  function handleDeleteAlertRecipient($event, alertRecipient) {
    return _showDeleteAlertRecipientDialog($event, alertRecipient);
  }

  function handleEditVendorFormSubmit() {
    if ($scope.editVendorForm.$valid) {
      loaderService.showViewLoader = true;
      _saveVendor().then(() => {
        _closeDialog().then(() => {
          loaderService.showViewLoader = false;
          if (vm.saveType === 'saveAndAddAnother') {
            $timeout(() => {
              _showEditVendorDialog(undefined, {
                vendor: vmSharedModelService.createNewVendor({ sdnScore: -1 }),
                addCallback: vm.addCallback
              });
            }, 0);
          }
        });
      });
    }
  }

  /** ****************************************
   * Private Functions
   */

  function _saveVendor() {
    const isNew = vm.newVendor.vendorId < 0;

    _updateAddressFields();

    if (!isNew && angular.equals(vm.vendor, vm.newVendor)) {
      // No need to save
      return Promise.resolve();
    }

    loaderService.showViewLoader = true;

    return vmSharedModelService.saveVendor(vm.newVendor).then((vendor) => {
      if (isNew) {
        // Only extend when new because the collections will be empty (light-version of vendor)
        angular.extend(vm.newVendor, vendor);
      }
      angular.extend(vm.vendor, vm.newVendor);
      if (isNew) {
        vm.addCallback(vm.vendor);
      }
      alerts.success(`The Vendor "${vm.vendor.name}" has been successfully saved.`);
    })
    .finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _updateAddressFields() {
    if ((vm.newVendor.countryId === 1) || (vm.newVendor.countryId === '1')) {
      vm.newVendor.countryId = 1;
      vm.newVendor.street = vm.usaAddress.street;
      vm.newVendor.suite = vm.usaAddress.suite;
      vm.newVendor.city = vm.usaAddress.city;
      vm.newVendor.state = vm.usaAddress.state;
      vm.newVendor.zip = vm.usaAddress.zip;
      vm.newVendor.province = null;
      vm.newVendor.postalCode = null;
    } else {
      vm.newVendor.countryId = 2;
      vm.newVendor.street = vm.canadaAddress.street;
      vm.newVendor.suite = vm.canadaAddress.suite;
      vm.newVendor.city = vm.canadaAddress.city;
      vm.newVendor.province = vm.canadaAddress.province;
      vm.newVendor.postalCode = vm.canadaAddress.postalCode;
      vm.newVendor.state = null;
      vm.newVendor.zip = null;
    }
  }

  function _updateVendorModelsWithProductDelete(product) {
    const existingVendor = R.find(
      R.propEq('vendorId', product.vendorId),
      vmSharedModelService.vendors
    );
    if (existingVendor !== null) {
      const productIndex = R.findIndex(
        R.propEq('productId', product.productId),
        existingVendor.products
      );
      if (productIndex > -1) {
        existingVendor.products.splice(productIndex, 1);
      }
      existingVendor.products = R.sortBy(
        R.prop('name'),
        existingVendor.products
      );
    }

    // -- Remove from current vendor object as well
    if (vm.vendor !== null) {
      const indx = R.findIndex(
        R.propEq('productId', product.productId),
        vm.vendor.products
      );
      if (indx > -1) {
        vm.vendor.products.splice(indx, 1);
      }
      vm.vendor.products = R.sortBy(
        R.prop('name'),
        vm.vendor.products
      );
    }
  }

  /** ****************************************
   * Private Functions
   * DIALOGS
   */

  function _activate() {
    loaderService.showViewLoader = true;

    _initAddress();

    $q.all([
      theSafeSharedModelService.getStates(),
      theSafeSharedModelService.getProvinces(),
      vmSharedModelService.getUnusedMasterVendors(vm.vendor.masterVendorId)
    ])
      .then((results) => {
        loaderService.showViewLoader = false;
        vm.states = results[0];
        vm.provinces = results[1];
        vm.unusedMasterVendors = results[2];
      });

    $scope.$on('refreshVendorAddress', () => {
      _initAddress();
    });
  }
  function _initAddress() {
    if (vm.newVendor.countryId === 1) {
      vm.usaAddress = {
        street: vm.newVendor.street,
        suite: vm.newVendor.suite,
        city: vm.newVendor.city,
        state: vm.newVendor.state,
        zip: vm.newVendor.zip,
      };
      vm.canadaAddress = null;
    } else {
      vm.canadaAddress = {
        street: vm.newVendor.street,
        suite: vm.newVendor.suite,
        city: vm.newVendor.city,
        province: vm.newVendor.province,
        postalCode: vm.newVendor.postalCode,
      };
      vm.usaAddress = null;
    }
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.editVendorDialog);
  }

  function _showEditVendorDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editVendorDialog = ssDialogService.alert(
      editVendorDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editVendorDialog);
  }

  function _showEditProductDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editProductDialog = ssDialogService.alert(
      editProductDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editProductDialog);
  }

  function _showAssignVendorManagersDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.assignVendorManagersDialog = ssDialogService.alert(
      assignVendorManagersDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.assignVendorManagersDialog);
  }

  function _showEditAlertRecipientDialog($event, locals) {
    ssDialogService.dialogs.vendorManagement.editAlertRecipientDialog = ssDialogService.alert(
      editAlertRecipientDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.editAlertRecipientDialog);
  }

  function _showUnassignVendorManagerDialog($event, vendorManager) {
    ssDialogService.dialogs.vendorManagement.confirmUnassignVendorManagerDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Unassign Vendor Manager?',
        message: `Are you sure you want to unassign the Vendor Manager "${vendorManager.name}"?`,
        handleYesClick() {
          _handleConfirmUnassignVendorManager(vendorManager);
        },
        handleNoClick: _handleCancelUnassignVendorManager,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmUnassignVendorManagerDialog);
  }

  function _closeUnassignVendorManagerDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmUnassignVendorManagerDialog);
  }

  function _showDeleteProductDialog($event, product) {
    ssDialogService.dialogs.vendorManagement.confirmDeleteProductDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Product?',
        message: `Are you sure you want to delete the product "${product.name}"?`,
        handleYesClick() {
          _handleConfirmDeleteProduct(product);
        },
        handleNoClick: _handleCancelDeleteProduct,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDeleteProductDialog);
  }

  function _closeDeleteProductDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteProductDialog);
  }

  function _showDeleteAlertRecipientDialog($event, alertRecipient) {
    ssDialogService.dialogs.vendorManagement.confirmDeleteAlertRecipientDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Delete Alert Recipient?',
        message: `Are you sure you want to delete the Alert Recipient "${alertRecipient.name}"?`,
        handleYesClick() {
          _handleConfirmDeleteAlertRecipient(alertRecipient);
        },
        handleNoClick: _handleCancelDeleteAlertRecipient,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.vendorManagement.confirmDeleteAlertRecipientDialog);
  }

  function _closeDeleteAlertRecipientDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.vendorManagement.confirmDeleteAlertRecipientDialog);
  }

  function _handleAddedProduct(product) {
    if (!vm.newVendor.products) {
      vm.newVendor.products = [];
    }
    vm.newVendor.products.push(product);
    vm.newVendor.hasProducts = true;
    vm.newVendor.products = R.sortBy(
      R.prop('name'),
      vm.newVendor.products
    );
    angular.extend(vm.vendor, vm.newVendor);
  }

  function _handleAddedVendorManagers(vendorManagers) {
    vm.newVendor.vendorManagers = vendorManagers;
    vm.newVendor.vendorManagers = R.sortBy(
      R.prop('name'),
      vm.newVendor.vendorManagers
    );
    angular.extend(vm.vendor, vm.newVendor);
    $rootScope.$broadcast('refreshVMVendor', { vendorId: vm.vendor.vendorId });
  }

  function _handleAddedAlertRecipient(alertRecipient) {
    if (!vm.newVendor.alertRecipients) {
      vm.newVendor.alertRecipients = [];
    }
    vm.newVendor.alertRecipients.push(alertRecipient);
    vm.newVendor.hasProducts = true;
    vm.newVendor.alertRecipients = R.sortBy(
      R.prop('name'),
      vm.newVendor.alertRecipients
    );
    angular.extend(vm.vendor, vm.newVendor);
    $rootScope.$broadcast('refreshVMVendor', { vendorId: vm.vendor.vendorId });
  }

  function _handleCancelDeleteProduct() {
    _closeDeleteProductDialog();
  }

  function _handleConfirmDeleteProduct(product) {
    loaderService.showViewLoader = true;
    return vmSharedModelService.deleteProduct(product.productId)
      .then(() => {
        alerts.success(`The Product "${product.name}" has successfully been deleted.`);
        _updateVendorModelsWithProductDelete(product);
        vmSharedModelService.resetProductCache(product.vendorId);
        _closeDeleteProductDialog();
      })
      .catch(() => {
        alerts.error('An error occurred deleting the product.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelUnassignVendorManager() {
    _closeUnassignVendorManagerDialog();
  }

  function _handleConfirmUnassignVendorManager(vendorManager) {
    loaderService.showViewLoader = true;
    vmDataService.unassignVendorManager(vendorManager.vendorManagerId, vm.vendor.vendorId)
      .then(() => {
        loaderService.showViewLoader = false;
        // eslint-disable-next-line max-len
        alerts.success(`The Vendor Manager "${vendorManager.name}" has successfully been unassigned from the "${vm.vendor.name}" Vendor.`);
        angular.forEach(vm.vendor.vendorManagers, (existingVendorManager, index) => {
          if (existingVendorManager.vendorManagerId === vendorManager.vendorManagerId) {
            vm.vendor.vendorManagers.splice(index, 1);
          }
        });
        _closeUnassignVendorManagerDialog();
        $rootScope.$broadcast('refreshVMVendor', { vendorId: vm.vendor.vendorId });
      });
  }

  function _handleCancelDeleteAlertRecipient() {
    _closeDeleteAlertRecipientDialog();
  }

  function _handleConfirmDeleteAlertRecipient(alertRecipient) {
    loaderService.showViewLoader = true;
    return orgDataService.deleteAlertRecipient(alertRecipient.alertRecipientId)
      .then(() => {
        alerts.success(`The Alert Recipient "${alertRecipient.name}" has successfully been deleted.`);
        angular.forEach(vm.vendor.alertRecipients, (existingAlertRecipient, index) => {
          if (existingAlertRecipient.alertRecipientId === alertRecipient.alertRecipientId) {
            vm.vendor.alertRecipients.splice(index, 1);
          }
        });
        _closeDeleteAlertRecipientDialog();
        $rootScope.$broadcast('refreshVMVendor', { vendorId: vm.vendor.vendorId });
      })
      .catch(() => {
        alerts.error('An error occurred deleting the alert recipient.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }
}

EditVendorDialogController.$inject = [
  '$q',
  '$scope',
  '$timeout',
  '$rootScope',

  'alerts',
  'confirmDialog',
  'loaderService',
  'orgDataService',
  'ssDialogService',
  'theSafeSharedModelService',
  'userService',
  'vmDataService',
  'vmSharedModelService',
  'editProductDialog',
  'assignVendorManagersDialog',
  'editAlertRecipientDialog',
  'editVendorDialog',
];
